import * as React from 'react';
import dayjs from 'dayjs';
import DateInput from '../../atoms/Calendar/DateInput';

const isDispLog: boolean = true;

const checkFromTo = (from: Date, to: Date): boolean => {
  console.debug(`checkFrom from = ${from} to=${to}`, isDispLog);
  const f = dayjs(new Date(from));
  const t = dayjs(new Date(to));
  if (f.format('YYYY-MM-DD') === t.format('YYYY-MM-DD')) {
    return true;
  } else {
    return t.isAfter(f);
  }
};

type Props = {
  fromDate: Date;
  toDate: Date;
  onChange?: (fromDate: Date, toDate: Date) => void;
};

const RangeInputCalendar: React.FC<Props> = (props) => {
  const [fromData, setFromData] = React.useState<Date>(props.fromDate);
  const [toData, setToData] = React.useState<Date>(props.toDate);

  /**
   * カレンダー変更イベント(開始日)
   * @param value 
   */
  const onChangeFromCalendarValue = (value: string) => {
    var f = new Date(value);
    var t = toData;
    if (checkFromTo(f, t)) {
      setFromData(f);
      if (props.onChange) props.onChange(f, t);
    } else {
      setFromData(t);
    }
  };
  /**
   * カレンダー変更イベント(終了日)
   * @param value 
   */
  const onChangeToCalendarValue = (value: string) => {
    var f = fromData;
    var t = new Date(value);
    if (checkFromTo(f, t)) {
      setToData(t);
      if (props.onChange) props.onChange(f, t);
    } else {
      setToData(f);
    }
  };

  return (
    <table>
      <tbody>
        <tr>
          <td>
            <DateInput
              initialValue={dayjs(fromData).format('YYYY-MM-DD')}
              label={'from'}
              labelPosition={0}
              onDateChange={(e) => onChangeFromCalendarValue(e)}
            ></DateInput>
          </td>
          <td> ~ </td>
          <td>
            <DateInput
              initialValue={dayjs(toData).format('YYYY-MM-DD')}
              label={'to'}
              labelPosition={0}
              onDateChange={(e) => onChangeToCalendarValue(e)}
            ></DateInput>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default RangeInputCalendar;
